import { ReactNode } from "react";

export type Align = 'left'|'center'|'right';
export interface Column<K extends string> {
  key: K,
  title: string,
  align?: Align,
  className?: string,
}

interface Props<K extends string> {
  columns: Column<K>[],
  data: NoInfer<Record<K, ReactNode>>[],
  defaultAlign?: Align
}
export default function DataTable<K extends string>({ columns, data, defaultAlign = 'left' }: Props<K>) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            {columns.map(col => (
              <th key={col.key.toString()} className={`text-${col.align ?? defaultAlign} py-3 px-4 text-text-muted font-medium`}>{col.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((record, i) => (
            <tr key={i} className="border-b border-border hover:bg-background-tertiary">
              {columns.map(col => (
                <td className={`text-${col.align ?? defaultAlign} py-3 px-4 text-text-secondary ${col.className ?? ''}`}>{record[col.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
